import React from "react";
import { Label, Alert, Select, SelectOption } from "@americanexpress/dls-react";

const AuthorizedSignatoryPosition = ({ t, authorPositions, value, onChange, authErrors, submit }) => (
  <div className="col-md-12 col-xs-12 pad-2-b">
    <Label htmlFor="authPosition">{t("newuser.position")}</Label>
    <Select
      id="authPosition"
      className="select-position"
      value={value || ""}
      onBlur={(event) => { onChange("position", event.target.value); }}
      onChange={(event) => { onChange("position", event.target.value); }}
    >
      <SelectOption value="" />
      {authorPositions.map((position) => (
        <SelectOption key={position} value={position}>
          {position}
        </SelectOption>
      ))}
    </Select>

    {(authErrors.position || (submit && !value)) && (
      <Alert status="error">{t("newuser.rolerequired")}</Alert>
    )}
  </div>
);

export default AuthorizedSignatoryPosition;
